import styled, { createGlobalStyle } from "styled-components";

export const MobileBottomSheetGlobalStyles = createGlobalStyle`
  .mobile-bottom-sheet {
    z-index: 1600;
  }

  .mobile-bottom-sheet .ant-drawer-mask {
    background: rgba(0, 0, 0, 0.64);
  }

  .mobile-bottom-sheet.ant-drawer-content-wrapper,
  .mobile-bottom-sheet .ant-drawer-content-wrapper {
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    height: calc(100dvh - 28px) !important;
    max-height: calc(100dvh - 28px);
    max-width: none;
    margin: 0;
  }

  .mobile-bottom-sheet .ant-drawer-content {
    height: 100%;
    min-height: 0;
    overflow: hidden;
    border-radius: 28px 28px 0 0;
    background: #ffffff;
  }

  .mobile-bottom-sheet .ant-drawer-body {
    display: flex;
    height: 100%;
    min-height: 0;
    flex-direction: column;
    padding: 0 !important;
    overflow: hidden !important;
  }

  .mobile-bottom-sheet * {
    scrollbar-width: none;
  }

  .mobile-bottom-sheet *::-webkit-scrollbar {
    display: none;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet.ant-drawer-content-wrapper,
  .mobile-bottom-sheet.route-selector-bottom-sheet .ant-drawer-content-wrapper {
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    height: calc(100dvh - 68px) !important;
    max-height: calc(100dvh - 68px);
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .ant-drawer-content {
    border-radius: 18px 18px 0 0;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-handle,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-handle {
    width: 42px;
    height: 4px;
    margin: 8px auto 10px;
    background: #eeeeee;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-close,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-close {
    top: 18px;
    right: 22px;
    width: 26px;
    height: 26px;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-close span,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-close span {
    width: 18px;
    height: 18px;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-close span::after,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-close span::after {
    width: 18px;
    height: 2px;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-header,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-header {
    padding: 0 52px 16px 24px;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-title,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
  }

  .mobile-bottom-sheet.route-selector-bottom-sheet .mobile-bottom-sheet-body,
  .mobile-bottom-sheet-panel.route-selector-bottom-sheet .mobile-bottom-sheet-body {
    padding: 0 24px;
    overflow: hidden;
  }

  .mobile-bottom-sheet.mobile-date-picker-sheet .mobile-bottom-sheet-close,
  .mobile-bottom-sheet-panel.mobile-date-picker-sheet .mobile-bottom-sheet-close {
    top: 22px;
    right: 20px;
    width: 24px;
    height: 24px;
    z-index: 30;
  }

  .mobile-bottom-sheet.mobile-date-picker-sheet .mobile-bottom-sheet-close span,
  .mobile-bottom-sheet-panel.mobile-date-picker-sheet .mobile-bottom-sheet-close span {
    width: 14px;
    height: 14px;
  }

  .mobile-bottom-sheet.mobile-date-picker-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet.mobile-date-picker-sheet .mobile-bottom-sheet-close span::after,
  .mobile-bottom-sheet-panel.mobile-date-picker-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet-panel.mobile-date-picker-sheet .mobile-bottom-sheet-close span::after {
    width: 14px;
    height: 2px;
  }

  .mobile-bottom-sheet.passenger-selector-bottom-sheet .mobile-bottom-sheet-close,
  .mobile-bottom-sheet.cabin-selector-bottom-sheet .mobile-bottom-sheet-close,
  .mobile-bottom-sheet-panel.passenger-selector-bottom-sheet .mobile-bottom-sheet-close,
  .mobile-bottom-sheet-panel.cabin-selector-bottom-sheet .mobile-bottom-sheet-close {
    top: 12px;
    right: 14px;
    width: 24px;
    height: 24px;
    z-index: 30;
  }

  .mobile-bottom-sheet.passenger-selector-bottom-sheet .mobile-bottom-sheet-close span,
  .mobile-bottom-sheet.cabin-selector-bottom-sheet .mobile-bottom-sheet-close span,
  .mobile-bottom-sheet-panel.passenger-selector-bottom-sheet .mobile-bottom-sheet-close span,
  .mobile-bottom-sheet-panel.cabin-selector-bottom-sheet .mobile-bottom-sheet-close span {
    width: 14px;
    height: 14px;
  }

  .mobile-bottom-sheet.passenger-selector-bottom-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet.passenger-selector-bottom-sheet .mobile-bottom-sheet-close span::after,
  .mobile-bottom-sheet.cabin-selector-bottom-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet.cabin-selector-bottom-sheet .mobile-bottom-sheet-close span::after,
  .mobile-bottom-sheet-panel.passenger-selector-bottom-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet-panel.passenger-selector-bottom-sheet .mobile-bottom-sheet-close span::after,
  .mobile-bottom-sheet-panel.cabin-selector-bottom-sheet .mobile-bottom-sheet-close span::before,
  .mobile-bottom-sheet-panel.cabin-selector-bottom-sheet .mobile-bottom-sheet-close span::after {
    width: 14px;
    height: 2px;
  }

  .mobile-bottom-sheet.passenger-selector-bottom-sheet .mobile-bottom-sheet-body,
  .mobile-bottom-sheet.cabin-selector-bottom-sheet .mobile-bottom-sheet-body,
  .mobile-bottom-sheet-panel.passenger-selector-bottom-sheet .mobile-bottom-sheet-body,
  .mobile-bottom-sheet-panel.cabin-selector-bottom-sheet .mobile-bottom-sheet-body {
    padding: 0 20px 20px;
    overflow-y: auto;
  }
`;

export const SheetPanel = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  background: #ffffff;
`;

export const SheetHandle = styled.div`
  width: 68px;
  height: 5px;
  margin: 9px auto 18px;
  border-radius: 999px;
  background: #eeeeee;
  flex-shrink: 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 0 64px 16px 20px;
  flex-shrink: 0;
`;

export const Title = styled.h2`
  margin: 0;
  color: #050505;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 17px;
  right: 17px;
  width: 32px;
  height: 32px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #15162b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
`;

export const CloseMark = styled.span`
  position: relative;
  display: block;
  width: 22px;
  height: 22px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 22px;
    height: 2.5px;
    border-radius: 999px;
    background: currentColor;
    transform-origin: center;
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 20px 20px;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Footer = styled.div`
  flex-shrink: 0;
  padding: 12px 20px calc(16px + env(safe-area-inset-bottom));
  border-top: 1px solid #f1f1f1;
  background: #ffffff;
`;
